"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DoneAction = void 0;
const adaptivecards_1 = require("adaptivecards");
const commands_1 = require("../../_shared/commands");
const CardHelper_1 = require("../../_shared/utils/CardHelper");
const DoneAction = (title) => {
    // Task fetch is needed here to prevent iOS devices from following with a dialog chat event bug
    return CardHelper_1.CardHelper.create(adaptivecards_1.SubmitAction, {
        title: title || "Done",
        data: new commands_1.Command({ command: "/done" }).toTaskFetchCommand(),
    });
};
exports.DoneAction = DoneAction;
//# sourceMappingURL=DoneAction.js.map